import { RevealRequests } from '@/screens/reveal-requests';

export default function RevealRequestsRoute() {
  return <RevealRequests />;
}
